import GridCard from 'obvio/Organizations/Collection/Cards/GridCard'
import styled from 'styled-components'
import {useUserOrganizations} from 'obvio/Organizations/UserOrganizationsProvider'
import React from 'react'
import ListCard from 'obvio/Organizations/Collection/Cards/ListCard'
import FullPageLoader from 'lib/ui/layout/FullPageLoader'

export default function Collection(props: {showingListView: boolean}) {
  const {showingListView} = props
  const {organizations, loading} = useUserOrganizations()

  if (loading) {
    return <FullPageLoader />
  }

  const empty = organizations.length === 0
  if (empty) {
    return (
      <EmptyBox>
        <p>No organizations have been created</p>
      </EmptyBox>
    )
  }

  if (showingListView) {
    return (
      <>
        {organizations.map((o, idx) => (
          <ListCard key={o.id} organization={o} index={idx} />
        ))}
      </>
    )
  }

  return (
    <Grid>
      {organizations.map((o) => (
        <GridCard key={o.id} organization={o} />
      ))}
    </Grid>
  )
}

const column = `minmax(270px, auto)`

const Grid = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-gap: ${(props) => props.theme.spacing[8]};

  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    grid-template-columns: ${column} ${column};
    grid-template-rows: auto auto;
  }

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    grid-template-columns: ${column} ${column} ${column};
    grid-template-rows: auto auto auto;
  }

  @media (min-width: ${(props) => props.theme.breakpoints.lg}) {
    grid-template-columns: ${column} ${column} ${column} ${column};
    grid-template-rows: auto auto auto auto;
  }
`

const EmptyBox = styled.div`
  margin-top: ${(props) => props.theme.spacing[8]};
  text-align: center;
`
